import _ from "lodash";
import moment from "moment";
import { utils } from "../resbutler-utils";
import { Labels } from "../resbutler-utils/types/Labels";
import { Meals } from "../resbutler-utils/types/Meals";

export function getConfig() {
  const dataUnserialized = window.localStorage.getItem("butler:data");
  return dataUnserialized ? JSON.parse(dataUnserialized) : null;
}

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const buildDataFromDocs = (docs) => {
  const data = {};
  docs.forEach((doc) => {
    data[doc.id] = doc.data();
  });
  return data;
};

export function getMealsFiltered(date, restaurantId, labels: Labels, meals: Meals, zoneId): Meals {
  const now = moment.tz(zoneId);
  let mealsFiltered = {} as Meals;
  const dateMaestro = moment.tz(date, "YYYYMMDD", zoneId).endOf("day");
  if (!now.isSameOrAfter(dateMaestro) && labels) {
    const mealLabels = utils.getMealLabelIds(labels, zoneId, date, restaurantId);
    mealsFiltered = _.pickBy(meals, (meal, mId) => meal.restaurantId === restaurantId && meal.enabled && _.findKey(mealLabels, (ml: any) => ml.mealId === mId) !== undefined);
  } else {
    mealsFiltered = _.pickBy(meals, (meal) => meal.restaurantId === restaurantId && meal.enabled);
  }

  return mealsFiltered;
}
